import { isRequired } from '../../../utils/validation';

export const initialValues = {
  period: 0
};

export const fieldsProps = {
  period: {
    name: 'period',
    placeholder: 'Pilih Periode Aktif Pencatatan Manual',
    label: 'Periode Aktif Pencatatan Manual',
    data: [
      { label: '1 Hari', value: '1' },
      { label: '3 Hari', value: '3' },
      { label: '7 Hari', value: '7' },
      { label: '30 Hari', value: '30' },
      { label: 'Tanpa Batas Waktu', value: '0', disabled: true },
    ],
  }
};

export const validate = (values = initialValues) => {
  const { period } = values;
  const rules = {
    period: isRequired(period, 'Periode Aktif Pencatatan Manual harus dipilih'),
  };

  return rules;
};
